import Button from './button'

const Header = (className, text) => {
  return (
    <div className="top-nav">
        <Button className={"button"} href={"/Series"} name={"Series"} />
        <Button className={"button"} href={"/Mangi"} name={"Mangi"} />
    </div>
  )
}

export default Header